const Utils = {
  detectOS: () => {
    let userAgent = navigator.userAgent;
    if (/Android/i.test(userAgent)) {
      return "Android";
    } else if (/iPhone|iPad|iPod/i.test(userAgent)) {
      return "iOS";
    } else if (/Windows/i.test(userAgent)) {
      return "Windows";
    } else if (/Linux/i.test(userAgent)) {
      return "Linux";
    } else if (/Macintosh|Mac OS X/i.test(userAgent)) {
      return "Mac";
    } else {
      return "Unknown";
    }
  },
  getOSVersion: () => {
    const userAgent = navigator.userAgent;
    let osVersion = "";

    if (userAgent.indexOf("Windows") !== -1) {
      // Windows
      const match = userAgent.match(/Windows NT (\d+\.\d+)/);
      if (match) {
        osVersion = match[1];
      }
    } else if (userAgent.indexOf("Mac OS X") !== -1) {
      // macOS
      const match = userAgent.match(/Mac OS X (\d+[_\.]\d+(?:[_\.]\d+)?)/);
      if (match) {
        osVersion = match[1].replace(/_/g, ".");
      }
    } else if (userAgent.indexOf("Linux") !== -1) {
      // Linux
      const match = userAgent.match(/Linux/);
      if (match) {
        osVersion = "Linux";
      }
    } else if (userAgent.indexOf("Android") !== -1) {
      // Android
      const match = userAgent.match(/Android (\d+(\.\d+)?)/);
      if (match) {
        osVersion = match[1];
      }
    } else if (userAgent.indexOf("iOS") !== -1) {
      // iOS
      const match = userAgent.match(/OS (\d+(_\d+)?)/);
      if (match) {
        osVersion = match[1].replace(/_/g, ".");
      }
    }

    return osVersion;
  },
  browserCheck: () => {
    let userAgent = navigator.userAgent;
    // let browser = "Unknown";

    // Detect Chrome
    if (/Edg/.test(userAgent)) {
      // browser = "Microsoft Edge";
      return "Microsoft Edge";
    } else if (/Chrome/.test(userAgent) && !/Chromium/.test(userAgent)) {
      // browser = "Google Chrome";
      return "Google Chrome";
    }
    // Detect Chromium-based Edge

    // Detect Firefox
    else if (/Firefox/.test(userAgent)) {
      // browser = "Mozilla Firefox";
      return "Mozilla Firefox";
    }
    // Detect Safari
    else if (/Safari/.test(userAgent)) {
      // browser = "Apple Safari";
      return "Apple Safari";
    }
    // Detect Internet Explorer
    else if (/Trident/.test(userAgent)) {
      // browser = "Internet Explorer";
      return "Internet Explorer";
    }
    // console.log("current browser is : " + browser);
  },
  browserVersionCheck: () => {
    let userAgent = navigator.userAgent;
    // let browser = "Unknown";

    // Detect Chrome
    if (/Edg/.test(userAgent)) {
      // browser = "Microsoft Edge";
      return userAgent.match(/Edg\/(\d+)/)[1];
    } else if (/Chrome/.test(userAgent) && !/Chromium/.test(userAgent)) {
      // browser = "Google Chrome";
      return userAgent.match(/Chrome\/(\d+)/)[1];
    }
    // Detect Chromium-based Edge

    // Detect Firefox
    else if (/Firefox/.test(userAgent)) {
      // browser = "Mozilla Firefox";
      return userAgent.match(/Firefox\/(\d+)/)[1];
    }
    // Detect Safari
    else if (/Safari/.test(userAgent)) {
      // browser = "Apple Safari";
      return userAgent.match(/Version\/(\d+)/)[1];
    }
    // Detect Internet Explorer
    else if (/Trident/.test(userAgent)) {
      // browser = "Internet Explorer";
      return userAgent.match(/Trident\/\d+.*rv:(\d+)/)[1];
    }
    // console.log("current browser is : " + browser);
  },
  getSystemSpecs: () => {
    let browserData = navigator;
    return {
      cookieEnabled: browserData.cookieEnabled,
      downLink: browserData.connection?.downLink,
      rtt: browserData.connection?.rtt,
      effectiveType: browserData.connection?.effectiveType,
      language: browserData.language,
      hardwareConcurrency: browserData.hardwareConcurrency,
      deviceMemory: browserData.deviceMemory,
      pdfViewerEnabled: browserData.pdfViewerEnabled,
    };
  },
  getDateTimeInfo :() => {
    // Get the current date and time in UTC
    const currentDate = new Date();
    
    // Convert UTC time to Indian Standard Time (IST)
    currentDate.setHours(currentDate.getHours() + 5); // Add 5 hours for UTC+5
    currentDate.setMinutes(currentDate.getMinutes() + 30); // Add 30 minutes for UTC+5:30
    
    // Format the date and time as per the requirement
    const formattedDateTime = currentDate.toISOString().slice(0, -5);
    
    return formattedDateTime;
  },
  removeUserDetail: () => {
    localStorage.removeItem("userDetails");
    localStorage.removeItem("interviewDetails");
  },
  setUserDetail: (data) => {
    localStorage.setItem("userDetails", JSON.stringify(data));
  },
  getUserDetail: () => {
    let userDetail = localStorage.getItem("userDetails");
    if (userDetail) {
      userDetail = JSON.parse(userDetail);
      return userDetail;
    } else {
      return null;
    }
  },
  getTagColor: (index) => {
    const colors = [
      "processing",
      "success",
      "magenta",
      "volcano",
      "gold",
      "lime",
      "green",
      "cyan",
      "purple",
      "orange",
      "red",
    ];
    return colors[index % colors.length]; // rotate between the colors
  },
  getProfileData: () => {
    let userDetail = localStorage.getItem("userData");
    if (userDetail) {
      userDetail = JSON.parse(userDetail);
      return userDetail;
    } else {
      return null;
    }
  },
  convertSecondsToTime: (seconds) => {
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const remainingSeconds = Math.floor(seconds % 60);

    let timeString = "";

    if (hours > 0) {
      timeString += `${hours} hr`;
    }
    if (minutes > 0) {
      timeString += `${hours > 0 ? " " : ""}${minutes} min`;
    }
    if (remainingSeconds > 0 || (!hours && !minutes)) {
      // Show seconds if it's the only unit left
      timeString += `${hours || minutes ? " " : ""}${remainingSeconds} sec`;
    }

    return timeString;
  },
  converToDateMonthYear: (value) => {
    const preferredJoiningDate = value;
    let readableDate = "";
    if (preferredJoiningDate) {
      const date = new Date(preferredJoiningDate);
      const options = { year: "numeric", month: "short", day: "numeric" };
      readableDate = date.toLocaleDateString("en-US", options);
    }
    return readableDate;
  },
  toTitleCase: (text) => {
    if (!text) return "N/A";
    return text
      .toLowerCase()
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  },
  toParams: (objectRef) => {
    var params = "";
    for (var key in objectRef) {
      if (objectRef[key] && typeof objectRef[key] == "object") {
        params +=
          key.toString() +
          "=" +
          encodeURIComponent(
            decodeURIComponent(
              encodeURIComponent(JSON.stringify(objectRef[key]))
            )
          ) +
          "&";
      } else {
        params +=
          key.toString() + "=" + encodeURIComponent(objectRef[key]) + "&";
      }
    }
    return params.slice(0, -1);
  },
};

export default Utils;
